import JsonResponse from "csi/comm/JsonResponse";
import { ModalDialogProps } from "designSystem/components/dialog/ModalDialog";
import { FileSelect, FlexColumn, FlexRowCenter, FormControlLabel, SaveDialog, Text, TextField } from "designSystem/index";
import { ControllerProps } from "csi/middleware/common";
import { getFileUploadRequest } from "csi/service/fileService";
import { submitWriter } from "csi/service/writerService";
import xml from "csi/xml";
import Writer from "csi/xml/Writer";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, useState } from "react";

export interface ReviseProofProps extends ModalDialogProps, ControllerProps {
}

const ReviseProof: FunctionComponent<ReviseProofProps> = observer((props) => {
	const { actionController, onSave, ...otherProps } = props;

	const document = actionController.getNode();
	const currentRevision = actionController.m_cache.getNode(document.CurrentRevision);

	const [documentName, setDocumentName] = useState(document.$Name);
	const [selectedFile, setSelectedFile] = useState<File>(null);

	const save = async () => {
		onSave(reviseDocument());
		return true;
	};

	const reviseDocument = async () => {
		// Revise Document and Update file
		const res: JsonResponse = await getFileUploadRequest(selectedFile, null, currentRevision.$URL, "Images", "File", true, false, false, "Proofing", "ReviseProof")
			.go();

		// Update document name if changed
		if (documentName != document.$Name) {
			const writer = new Writer();
			writer.changeNode(document.$URL)
				.changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, documentName);
			await submitWriter(writer);
		}
		actionController.widget.refreshData();
		return res;
	};


	return (
		<SaveDialog
			disableSave={!documentName || !selectedFile}
			onSave={save}
			{...otherProps}
		>
			{{
				main: (
					<FlexColumn px={5}>
						<FlexRowCenter justifyContent="flex-end">
							<FormControlLabel
								control={<FileSelect onFileSelect={(file) => setSelectedFile(file)} sx={{ width: 326 }} />}
								label={<Text bold res="DocumentRevision.Attr.File" />}
								labelPlacement="start"
							/>
						</FlexRowCenter>
						<FlexRowCenter justifyContent="flex-end" mt={6}>
							<FormControlLabel
								control={(
									<TextField
										autoFocus
										name="documentName"
										onChange={(event) => setDocumentName(event.target.value)}
										sx={{ width: 352 }}
										value={documentName}
									/>
								)}
								label={<Text bold res="Document.Name" />}
								labelPlacement="start"
							/>
						</FlexRowCenter>
					</FlexColumn>
				),
			}}
		</SaveDialog>
	);
});

export default ReviseProof;

